import logParams from 'helpers/logParams'
import React, {useRef, useState} from 'react'
import useKey from 'react-use/lib/useKey'
import classNames from "classnames";

export const SelectList = ({ children = [], onSelected = logParams, className, }) => {
  // version chỉ dùng để force re-render khi keyboard navigation thay đổi selectedkey
  // KHÔNG dùng để track children changes — children được render trực tiếp, không qua Pure
  const [version, setVersion] = useState(0)
  const ref = useRef({
    selectedkey: 0,
    length: 0,
  })

  // Sync length mỗi render mà không trigger re-render thêm
  // Children render trực tiếp nên không cần setVersion khi children thay đổi
  ref.current.children = children
  ref.current.length = children.length
  // Clamp selectedkey nếu list ngắn lại
  if (ref.current.selectedkey >= children.length && children.length > 0) {
    ref.current.selectedkey = children.length - 1
  }

  useKey('ArrowUp', () => {
    if (ref.current.length === 0) return
    ref.current.selectedkey =
        (ref.current.length - 1 + ref.current.selectedkey) % ref.current.length
    setVersion(v => v + 1)
  })
  useKey('Enter', () => {
    onSelected(
        ref.current.children[ref.current.selectedkey],
        ref.current.selectedkey
    )
  })
  useKey('ArrowDown', () => {
    if (ref.current.length === 0) return
    ref.current.selectedkey =
        (ref.current.length + 1 + ref.current.selectedkey) % ref.current.length
    setVersion(v => v + 1)
  })

  return (
      <div className={classNames("space-y-1", className)}>
        {children.map((e, index) => (
            <div
                style={{
                  background: index === ref.current.selectedkey
                      ? 'var(--background-100)'
                      : `var(--background-${index})`,
                  borderBottom: index === 0 && children.length > 1
                      ? 'solid 1px var(--border-color-50)'
                      : undefined,
                }}
                key={index}>
              {e}
            </div>
        ))}
      </div>
  )
}